import { Outlet } from "react-router-dom"
import { useSelector } from "react-redux";
import LoginPage from "pages/login";

function PrivateRoute ({auth, join=false}) {
  const { authenticated } = useSelector(state => state.authToken);
  
  if (authenticated || !auth || join) {
    return <Outlet />;
  } else {
    return <LoginPage />;
  }
}

export default PrivateRoute